/**
 * Created by mac on 6/28/20
 */

const Referee = function (options) {
    this.options = options;

    const levelNo = options.level - 1;
    const level = new Level(Math.floor(levelNo / 15), levelNo % 15);

    this.onResult = function (statistics) {
        console.log("Referee:");
        console.log(statistics);
    };

    this.prepare();

    cleverapps.bundleLoader.loadBundle(level.bundleId(), {
        onSuccess: () => {
            level.setupContent();

            const started = Date.now();

            // console.log("Loaded level")

            this.fullSeason(level, (statistics) => {
                const elapsed = Date.now() - started;

                console.log(`Time: ${elapsed} rate: ${elapsed / statistics.runs}`);
                this.onResult(statistics);

                this.restore();
            });
        }
    });
};

Referee.prototype.prepare = function () {
    this.oldCollect = Mark.prototype.collect;
    Mark.prototype.collect = function () {};

    this.oldInAnimation = Card.prototype.inAnimation;
    Card.prototype.inAnimation = function () {
        return false;
    };

    const oldSetTimeout = this.oldSetTimeout = setTimeout;
    // eslint-disable-next-line no-global-assign
    setTimeout = function (callback, timeout) {
        // console.log('SetTimeout ' + timeout, callback);
        // if (timeout === 400)
        // throw 1

        oldSetTimeout(callback, timeout);
    };

    this.oldTimeredThrottle = cleverapps.timeredThrottle;

    const oldGameBase = this.oldGameBase = GameBase;
    GameBase = function (level, options) {
        oldGameBase.apply(this, arguments);
        PseudoRandom.GET().seed(options.seed);
    };
};

Referee.prototype.restore = function () {
    Mark.prototype.collect = this.oldCollect;
    // eslint-disable-next-line no-global-assign
    setTimeout = this.oldSetTimeout;

    Card.prototype.inAnimation = this.oldInAnimation;

    cleverapps.timeredThrottle = this.oldTimeredThrottle;

    GameBase = this.oldGameBase;
};

Referee.prototype.singleGame = function (id, level, callback) {
    const tripeaks = new TriPeaks(level, {
        seed: id
    });

    const rapidTimeout = new RapidTimeout();
    tripeaks.counter.setTimeout = rapidTimeout.setTimeout.bind(rapidTimeout);

    const bot = new AutoBot(id, tripeaks, this.options);

    let totalMoves = 0;

    const stop = function (options) {
        moveProcessor = function () {};
        rapidTimeout.stop();
        tripeaks.stop();

        callback(options);
    };

    let moveProcessor = function () {
        // console.log('Move' + id + ' #', totalMoves)
        totalMoves++;
        if (totalMoves <= 100) {
            bot.makeMove();
        } else {
            console.log(`TOO LONG: ${id}`);
            stop();
        }
    };

    bot.done = function (statistics) {
        if (this.options.log || 1) {
            console.log(`DONE: ${id}`, statistics);
        }

        stop(statistics);
    }.bind(this);

    tripeaks.counter.registerStage(1000000, moveProcessor);
    tripeaks.shiftCard();
    tripeaks.counter.trigger();
};

Referee.prototype.fullSeason = function (level, callback) {
    const totals = {};
    let amount = 0;

    const playOnce = function (f, index) {
        if (this.options.draw) {
            if (Array.isArray(this.options.draw) && this.options.draw.indexOf(index) === -1 || this.options.draw !== index) {
                f();
                return;
            }
        }

        // console.log("Starting a game")
        this.singleGame(index, level, (stats) => {
            for (const key in stats) {
                totals[key] = (totals[key] || 0) * amount + stats[key];
            }

            amount++;

            for (const KEY in stats) {
                totals[KEY] /= amount;
            }

            totals.runs = amount;

            f();
        });
    }.bind(this);

    const runs = [];
    for (let i = 0; i < this.options.runs; i++) {
        runs.push(i);
    }

    const player = new ActionPlayer(runs.map((i) => function (f) {
        setTimeout(() => {
            playOnce(f, i);
        }, 0);
    }));

    player.play(() => {
        callback(totals);
    });
};